var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 318.18 295",
    style: {
      enableBackground: "new 0 0 318.18 295"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000023991236220290808320000001283291699488887967_);}\n\t.st2{fill:url(#SVGID_00000169531946243486154590000008389931847249842598_);}\n\t.st3{fill:url(#SVGID_00000126301105480396296040000014137260627419872440_);}\n\t.st4{fill:url(#SVGID_00000069395420595738282360000011490156125073869238_);}\n\t.st5{fill:url(#SVGID_00000166670528279350012220000005479604874301280908_);}\n\t.st6{fill:url(#SVGID_00000152951959709135655040000012052655730255244720_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1108.1371,
    y1: -1105.5135,
    x2: 850.9674,
    y2: 714.0559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.15,82.87c10.36,0,18.78-8.43,18.78-18.78c0-10.36-8.43-18.78-18.78-18.78 c-10.36,0-18.78,8.43-18.78,18.78C132.37,74.44,140.79,82.87,151.15,82.87z M151.15,52.84c6.2,0,11.24,5.04,11.24,11.24 s-5.04,11.24-11.24,11.24c-6.2,0-11.24-5.04-11.24-11.24S144.95,52.84,151.15,52.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155859272944256948010000003220008997120920709_",
    gradientUnits: "userSpaceOnUse",
    x1: -1183.7643,
    y1: -1024.0823,
    x2: 775.3384,
    y2: 795.4855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155859272944256948010000003220008997120920709_)"
    },
    d: "M163.85,208.77 c-10.36,0-18.78,8.43-18.78,18.78c0,10.36,8.43,18.78,18.78,18.78c10.36,0,18.78-8.43,18.78-18.78 C182.64,217.2,174.21,208.77,163.85,208.77z M163.85,238.79c-6.2,0-11.24-5.04-11.24-11.24s5.04-11.24,11.24-11.24 c6.2,0,11.24,5.04,11.24,11.24S170.05,238.79,163.85,238.79z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046313427718830170430000005141888183225723565_",
    gradientUnits: "userSpaceOnUse",
    x1: -1145.9517,
    y1: -1064.7986,
    x2: 813.1533,
    y2: 754.7713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046313427718830170430000005141888183225723565_)"
    },
    d: "M270.67,91.75h-80.5 c1.43-2.03,2.73-4.17,3.87-6.46c1.28-2.59,4.77-4.86,7.46-4.86h18.88c1,0,1.96-0.4,2.67-1.11l9.58-9.58L242.89,80 c0.71,0.71,1.67,1.11,2.67,1.11c1,0,1.96-0.4,2.67-1.11l10.23-10.23l9.55,9.55c1.41,1.42,3.92,1.42,5.33,0l12.57-12.58 c0.71-0.71,1.11-1.67,1.11-2.67c0-1-0.4-1.96-1.11-2.67l-12.57-12.57c-0.71-0.71-1.67-1.1-2.67-1.1h-69.15 c-3.13,0-6.01-1.9-7.54-4.95c-8.15-16.34-24.54-26.49-42.77-26.49c-14.32,0-27.77,6.35-36.89,17.41 c-9.12,11.06-12.75,25.61-9.97,39.93c1.29,6.63,4.02,12.76,7.82,18.11H44.33c-9.01,0-16.35,7.33-16.35,16.35v75.45 c0,9.01,7.33,16.35,16.35,16.35h80.51c-1.42,2-2.71,4.12-3.83,6.37c-1.52,3.05-4.41,4.95-7.54,4.95H44.33c-1,0-1.96,0.4-2.67,1.11 l-12.57,12.57c-1.47,1.47-1.47,3.86,0,5.33l12.57,12.58c1.41,1.42,3.92,1.42,5.33,0l9.55-9.55l10.23,10.23 c1.41,1.42,3.92,1.42,5.33,0l10.26-10.26l9.58,9.58c0.71,0.71,1.67,1.11,2.67,1.11h18.88c2.69,0,6.18,2.27,7.46,4.86 c8.24,16.61,24.75,26.58,42.81,26.58c3.02,0,6.08-0.28,9.16-0.85c18.89-3.52,34.04-18.53,37.71-37.37 c2.56-13.18-0.32-26.55-7.91-37.22h67.94c9.01,0,16.35-7.33,16.35-16.35v-75.45C287.02,99.08,279.69,91.75,270.67,91.75z  M120.15,38.51c7.68-9.32,19-14.66,31.07-14.66c15.36,0,29.16,8.55,36.02,22.31c2.81,5.63,8.28,9.13,14.29,9.13h67.59l8.8,8.8 l-7.24,7.24l-9.55-9.55c-1.47-1.47-3.86-1.47-5.33,0L245.55,72l-10.26-10.26c-1.41-1.42-3.92-1.42-5.33,0l-11.15,11.15H201.5 c-5.55,0-11.66,3.89-14.22,9.05c-2.01,4.05-4.61,7.63-7.65,10.68c-0.15,0.12-0.29,0.25-0.42,0.4c-9.2,8.95-22.34,13.09-35.76,10.59 c-7.81-1.45-14.85-5.25-20.36-10.61c-0.11-0.12-0.22-0.22-0.34-0.32c-5.52-5.49-9.45-12.58-10.98-20.46v0 C109.42,60.1,112.47,47.82,120.15,38.51z M203.24,235.67c-3.08,15.83-15.81,28.44-31.68,31.4c-18.12,3.37-35.73-5.33-43.83-21.66 c-2.56-5.16-8.67-9.05-14.22-9.05H96.19l-11.15-11.15c-1.41-1.42-3.92-1.42-5.33,0l-10.26,10.26l-10.23-10.23 c-1.47-1.47-3.86-1.47-5.33,0l-9.55,9.55l-7.24-7.24l8.8-8.8h67.59c6,0,11.48-3.5,14.29-9.13c2.03-4.07,4.67-7.66,7.77-10.73 c0.09-0.09,0.18-0.18,0.27-0.27c7.37-7.16,17.29-11.31,27.98-11.31c10.6,0,20.64,4.13,28.13,11.46c0,0,0.01,0.01,0.01,0.01 c1.03,1.01,2.01,2.07,2.93,3.19C202.54,211.29,205.59,223.57,203.24,235.67z M279.48,183.54c0,4.85-3.95,8.8-8.8,8.8h-74.6 c-8.76-8.05-20.21-12.57-32.28-12.57c-12.26,0-23.68,4.6-32.32,12.57H44.33c-4.85,0-8.8-3.95-8.8-8.8v-75.45 c0-4.85,3.95-8.8,8.8-8.8h74.5c6.41,5.89,14.4,10.08,23.24,11.72c3.07,0.57,6.14,0.85,9.16,0.85c12.17,0,23.63-4.54,32.33-12.57 h87.12c4.85,0,8.8,3.95,8.8,8.8V183.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111882010910333478890000011277645105416458652_",
    gradientUnits: "userSpaceOnUse",
    x1: -1183.7998,
    y1: -1024.0476,
    x2: 775.3026,
    y2: 795.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111882010910333478890000011277645105416458652_)"
    },
    d: "M97.92,133.04 c-1.04-1.8-3.35-2.42-5.15-1.38l-13.22,7.63v-15.26c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v15.26l-13.21-7.63 c-1.8-1.04-4.11-0.42-5.15,1.38c-1.04,1.8-0.42,4.11,1.38,5.15l13.21,7.63l-13.21,7.63c-1.8,1.04-2.42,3.35-1.38,5.15 c0.7,1.21,1.97,1.89,3.27,1.89c0.64,0,1.29-0.16,1.88-0.51l13.21-7.63v15.26c0,2.08,1.69,3.77,3.77,3.77s3.77-1.69,3.77-3.77 v-15.26l13.22,7.63c0.59,0.34,1.24,0.51,1.88,0.51c1.3,0,2.57-0.68,3.27-1.89c1.04-1.8,0.42-4.11-1.38-5.15l-13.21-7.63l13.21-7.63 C98.34,137.15,98.96,134.84,97.92,133.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131369749720346699450000001690606133147595688_",
    gradientUnits: "userSpaceOnUse",
    x1: -1158.5677,
    y1: -1051.2148,
    x2: 800.5383,
    y2: 768.356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131369749720346699450000001690606133147595688_)"
    },
    d: "M152.4,133.04 c-1.04-1.8-3.35-2.42-5.15-1.38l-13.21,7.63v-15.26c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v15.26l-13.22-7.63 c-1.81-1.04-4.11-0.42-5.15,1.38c-1.04,1.8-0.42,4.11,1.38,5.15l13.21,7.63l-13.21,7.63c-1.8,1.04-2.42,3.35-1.38,5.15 c0.7,1.21,1.97,1.89,3.27,1.89c0.64,0,1.29-0.16,1.88-0.51l13.22-7.63v15.26c0,2.08,1.69,3.77,3.77,3.77 c2.08,0,3.77-1.69,3.77-3.77v-15.26l13.21,7.63c0.59,0.34,1.24,0.51,1.88,0.51c1.3,0,2.57-0.68,3.27-1.89 c1.04-1.8,0.42-4.11-1.38-5.15l-13.21-7.63l13.21-7.63C152.82,137.15,153.44,134.84,152.4,133.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033349422127075360840000014350938784602663818_",
    gradientUnits: "userSpaceOnUse",
    x1: -1133.3341,
    y1: -1078.3815,
    x2: 825.7687,
    y2: 741.1863
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033349422127075360840000014350938784602663818_)"
    },
    d: "M206.88,133.04 c-1.04-1.8-3.35-2.42-5.15-1.38l-13.21,7.63v-15.26c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v15.26l-13.21-7.63 c-1.81-1.04-4.11-0.42-5.15,1.38c-1.04,1.8-0.42,4.11,1.38,5.15l13.21,7.63l-13.21,7.63c-1.8,1.04-2.42,3.35-1.38,5.15 c0.7,1.21,1.97,1.89,3.27,1.89c0.64,0,1.29-0.16,1.88-0.51l13.21-7.63v15.26c0,2.08,1.69,3.77,3.77,3.77 c2.08,0,3.77-1.69,3.77-3.77v-15.26l13.21,7.63c0.59,0.34,1.24,0.51,1.88,0.51c1.3,0,2.57-0.68,3.27-1.89 c1.04-1.8,0.42-4.11-1.38-5.15l-13.21-7.63l13.21-7.63C207.31,137.15,207.93,134.84,206.88,133.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111887713840490962150000001781564591483370128_",
    gradientUnits: "userSpaceOnUse",
    x1: -1108.1023,
    y1: -1105.5488,
    x2: 850.9993,
    y2: 714.0178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0151,
    style: {
      stopColor: "#4471B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8052A1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111887713840490962150000001781564591483370128_)"
    },
    d: "M261.37,133.04 c-1.04-1.8-3.35-2.42-5.15-1.38L243,139.28v-15.26c0-2.08-1.69-3.77-3.77-3.77c-2.08,0-3.77,1.69-3.77,3.77v15.26l-13.21-7.63 c-1.81-1.04-4.11-0.42-5.15,1.38c-1.04,1.8-0.42,4.11,1.38,5.15l13.21,7.63l-13.21,7.63c-1.8,1.04-2.42,3.35-1.38,5.15 c0.7,1.21,1.97,1.89,3.27,1.89c0.64,0,1.29-0.16,1.88-0.51l13.21-7.63v15.26c0,2.08,1.69,3.77,3.77,3.77 c2.08,0,3.77-1.69,3.77-3.77v-15.26l13.21,7.63c0.59,0.34,1.24,0.51,1.88,0.51c1.3,0,2.57-0.68,3.27-1.89 c1.04-1.8,0.42-4.11-1.38-5.15l-13.21-7.63l13.21-7.63C261.79,137.15,262.41,134.84,261.37,133.04z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep01);
export default __webpack_public_path__ + "static/media/step_01.bfb72b93d91a8812b41d4d6f18d0794b.svg";
export { ForwardRef as ReactComponent };